module.exports = __webpack_public_path__ + "static/img/exam-sys.3b32611.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/exam-sys.png
// module id = sZJI
// module chunks = 1